import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import Toast from '../components/Toast';

const ToastContext = createContext(null);

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within ToastProvider');
  }
  return context;
};

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message, type = 'info') => {
    setToast({ message, type });
  }, []);

  const hideToast = useCallback(() => {
    setToast(null);
  }, []);

  // Allow non-React code (e.g. Axios interceptors) to trigger a toast
  useEffect(() => {
    const handler = (event) => {
      const detail = event?.detail || {};
      const message = detail.message;
      if (!message) return;
      showToast(message, detail.type || 'info');
    };

    window.addEventListener('oikra:toast', handler);
    return () => window.removeEventListener('oikra:toast', handler);
  }, [showToast]);

  return (
    <ToastContext.Provider value={{ toast, showToast, hideToast }}>
      {children}
      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={hideToast}
          duration={3000}
        />
      )}
    </ToastContext.Provider>
  );
};
